import {Component, Input, OnInit} from '@angular/core';
import {AppConfigService} from "../../../config/app-config.service";

@Component({
  selector: 'app-descriptor-metadata-list',
  templateUrl: './descriptor-metadata-list.component.html',
  styleUrls: ['./descriptor-metadata-list.component.scss']
})
export class DescriptorMetadataListComponent implements OnInit {

  _list = [];

  @Input() set list(value: string[]) {
    if (value && value instanceof Array) {
      this._list = value.sort((a, b) => a.localeCompare(b));
    }
  }

  @Input() disableShowMore: false;

  showMore = false;

  constructor(public appConfig: AppConfigService) {
  }

  ngOnInit() {
  }

  setShowMore(): void {
    this.showMore = true;
  }

  setShowLess(): void {
    this.showMore = false;
  }

}
